/**
 * WordPress dependencies
 */
import { createRoot, useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

/**
 * External dependencies
 *
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, useSearchParams } from 'react-router-dom';

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
});

/**
 * Internal dependencies
 */
import CourseFilter from './components/CourseFilter';
import CourseResults from './components/CourseResults';
import { useLocalEvents } from '@hooks';

/**
 * Main Component
 */
function Main() {
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		data,
		isPending,
		isError,
		refetch: refetchCallback,
	} = useLocalEvents({
		group: true,
		filter: {
			categories: searchParams.get('category')?.split(',') || [],
			venues: searchParams.get('venue')?.split(',') || [],
			countries: searchParams.get('country')?.split(',') || [],
			statuses: searchParams.get('status')?.split(',') || [],
		},
	});

	useEffect(() => {
		refetchCallback();
	}, [searchParams]);

	return (
		<>
			<CourseFilter filters={window.visitEduSettings.filters} />
			<CourseResults
				data={data}
				isPending={isPending}
				isError={isError}
			/>
		</>
	);
}

/**
 * Render block
 */
domReady(function () {
	createRoot(document.getElementById('course-calendar')).render(
		<Router>
			<QueryClientProvider client={queryClient}>
				<Main />
			</QueryClientProvider>
		</Router>
	);
});
